@if(!hideImportModule) {
<div class="grid">
  <div class="col-12">
    <div class="mb-5">
      <p-message class="messages-import" severity="info"  [closable]="false">
        <ng-template #icon>
          <i class="pi pi-info-circle text-lg-custom"></i>
        </ng-template>
         
          <div class="ml-2">
            <div class="font-semibold link mb-1" [innerHTML]="'importFile.info' | translate"></div>
           <!--   <div class="font-semibold link" [innerHTML]="'importFile.warnImportCsvFileFormat' | translate"></div> -->
          </div>
      </p-message>
    </div>
    <p-fileUpload name="file" [multiple]="false" accept=".xlsx, .xls, .csv, .json" maxFileSize="200000000"
      customUpload="true" (onSelect)="onSelectedFiles($event)" (uploadHandler)="onUploadHandler($event)" #fileUpload>
      <ng-template pTemplate="header" let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
        let-uploadCallback="uploadCallback">

        <div class="flex flex-column gap-4">
          
          <!-- Message warning -->
          <div>
            <p-message severity="warn" [closable]="false">
              <ng-template #icon>
              <i class="pi pi-exclamation-triangle" style="font-size: 1.5rem"></i>
              </ng-template>
              <div class="pl-3 font-semibold" [innerHTML]="'importFile.warnImportCsvFileFormat' | translate"></div>
            </p-message>
          </div>

          <!-- Stepper -->
     <div class="flex justify-content-center">
      <p-stepper [value]="active">
        <p-step-item [value]="1">
          <p-step>
            <ng-template #content>
              <div class="flex align-items-center gap-2">
                <p-badge [value]="'1'" class="mr-2" />
                <p-button
                  (click)="choose($event, chooseCallback); active = 1"
                  icon="pi pi-file-import"
                  [disabled]="files && files.length > 0"
                  pTooltip="{{ 'tooltips.selectFile' | translate }}" />
              </div>
            </ng-template>
          </p-step>
          <p-step-panel>
            <ng-template #content></ng-template>
          </p-step-panel>
        </p-step-item>
        <div style="height: 2px; width: 2rem; background-color: #dee2e6; align-self: center;"></div>    
        <p-step-item [value]="2">
          <p-step>
            <ng-template #content>
              <div class="flex align-items-center gap-2">
                <p-badge [value]="'2'" severity="success" class="mr-2" />
                <p-button
                  (click)="uploadEvent(uploadCallback, fileUpload); active = 2"
                  icon="pi pi-cloud-upload"
                  severity="success"
                  [disabled]="!files || files.length === 0 || statrtUpload"
                  pTooltip="{{ 'tooltips.uploadFile' | translate }}" />
              </div>
            </ng-template>
          </p-step>
          <p-step-panel>
            <ng-template #content></ng-template>
          </p-step-panel>
        </p-step-item>
        <div style="height: 2px; width: 2rem; background-color: #dee2e6; align-self: center;"></div>
        <p-step-item [value]="3">
          <p-step>
            <ng-template #content>
              <p-button
                (click)="clearCallback(); resetActive()"
                icon="pi pi-times"
                severity="danger"
                [disabled]="!files || files.length === 0"
                pTooltip="{{ 'tooltips.cancelUpload' | translate }}" />
            </ng-template>
          </p-step>
          <p-step-panel>
            <ng-template #content></ng-template>
          </p-step-panel>
        </p-step-item>
      </p-stepper>
    </div>

          <!-- Progress bar -->
          @if (progress > 0) {
            <div>
              <p-progressBar
                [value]="progress"
                [showValue]="false"
                styleClass="md:w-20rem h-1rem w-full md:ml-auto"
                [ngClass]="{ 'exceeded-progress-bar': progress > 100 }">
                <span class="white-space-nowrap">{{ totalSize }}B / 1Mb</span>
              </p-progressBar>
            </div>
          }

        </div>

      </ng-template>
      <ng-template let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
        let-uploadCallback="uploadCallback" pTemplate="empty">
        <div class="flex align-items-center justify-content-center flex-column">
          <i class="pi pi-cloud-upload text-2xl text-400 border-400"></i>
          <p class="mt-4 mb-0">
            {{ "importFile.empty" | translate }}
          </p>
        </div>
      </ng-template>
    </p-fileUpload>
  </div>
  <!-- <div class="lg:col-2 md:col-4 sm:col-6">
      <div class="">
        <p-divider align="center" type="solid">
          <b>OU</b>
        </p-divider>
        <div class="mb-3 text-center">
          <span>
            {{ "importFile.createFileMessage" | translate }}
          </span>
        </div>
        <div class="flex flex-column align-items-center gap-3">
          <p-button
            label="{{ 'importFile.createFile' | translate }}"
            icon="pi pi-file"
            class="mt-3"
            [outlined]="true" />
        </div>
      </div>
    </div> -->
</div>
<div class="mt-5 flex justify-content-start gap-2 align-items-center">
  <i class="pi pi-check-circle mt-2" style="font-size: 1.5rem; color: #ba320d"></i>
  <h5 style="color: #ba320d; text-decoration: underline;">{{'global.awaitingActions' | translate}}</h5>
</div>
<div>
  <app-import-history [hideFilters]="true" [hideSearch]="true" [status]="['AWAITING_MAPPING']" [hasNext]="hasNext"
    [shopsFilters]="shopsFilters" [onRowClick]="true" #importHistoryComponent></app-import-history>
</div>

<p-toast></p-toast>

<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
      <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
        <i class="pi pi-question text-5xl"></i>
      </div>
      <span class="font-bold text-2xl block mb-2 mt-4">
        {{ message.header }}
      </span>
      <div class="mb-0 text-center text-base" [innerHTML]="message.message"></div>
      <div class="mt-2">
        <p-message severity="info"   [closable]="false">
            <div class="pl-2" style="width: 350px; color: black"
              [innerHTML]="'importFile.confirmDialogInfo' | translate"></div>
        </p-message>
      </div>
      <div class="flex align-items-center gap-2 mt-4">
        <button pButton label="{{ 'buttons.confirm' | translate }}" (click)="cd.onAccept()" class="w-8rem"></button>
        <button pButton label="{{ 'buttons.cancel' | translate }}" (click)="cd.onReject()"
          class="p-button-outlined w-8rem"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
} @else {
<div class="mt-5 mb-8">
  <p-message severity="info"   [closable]="false">
    <ng-template #icon>
      <i class="pi pi-info-circle" style="font-size: 1.5rem"></i>
    </ng-template>
      <div class="pl-2" [innerHTML]="'importFile.noImportRightMessage' | translate"></div>
  </p-message>
</div>
}